import { useRouterSelector } from '~/hooks/useRouterSelector';
import { getSavedSearchIdFromPath } from '~/utils/PathUtils';

export const useSavedFilterIdSelector = () => {
  return useRouterSelector((location) => getSavedSearchIdFromPath(location.pathname));
};
